import { useRef, useEffect } from "react";

export function useWillUnmount(callback: () => any = () => {}) {
  const callbackRef = useRef(callback);
  callbackRef.current = callback;
  useEffect(() => {
    return () => callbackRef.current();
  }, []);
}
